import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({

  name: 'products',

  initialState: {
    items: [],
    selectedItem: null
  },


  reducers: {


    setItems(state, action) {

      state.items = action.payload;

    },


    // Add new product
    addItem(state, action) {

      state.items.unshift(action.payload);

    },


    // Update one product
    update(state, action) {

      const index = state.items.findIndex(
        item => item._id === action.payload._id
      );


      if(index !== -1){

        state.items[index] = action.payload;

      }

    },


    select(state, action) {

      state.selectedItem =
        state.items.find(
          element => element._id === action.payload
        ) || null;

    },


    remove(state, action) {

      state.items =
        state.items.filter(
          element => element._id !== action.payload
        );

    },


  },

});


export { actions as productsActions };

export { reducer as productsReducer };